import React, { useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  ReportsDetailDispatchContext,
  ReportsDetailStateContext,
} from "../context/reportsDetailProvider";
import { setOrderingBy, setOrderingDirection } from "../state/actions";
import ClientType from "./columnTypes/ClientType";
import CurrencyType from "./columnTypes/CurrencyType";
import DateType from "./columnTypes/DateType";
import Colors from "../../../../components/global/Colors";
import ProviderType from "./columnTypes/ProviderType";

const ReportTable = ({ data }) => {
  const state = useContext(ReportsDetailStateContext);
  const dispatch = useContext(ReportsDetailDispatchContext);

  const handleRequestSort = (event, property) => {
    const isAsc =
      state.orderingBy === property && state.orderingDirection === "asc";
    setOrderingDirection(dispatch, isAsc ? "desc" : "asc");
    setOrderingBy(dispatch, property);
  };
  const formatColumns = (columnType, value) => {
    switch (columnType) {
      case "ClientColumn":
        return <ClientType clientObj={value} />;
      case "DateTimeColumn":
        return <DateType date={value.value} newLine={true} />;
      case "DecimalColumn":
        return <CurrencyType amount={value.value} />;
      case "ProviderColumn":
        return (
          <ProviderType providerId={value.id} providerName={value.value} />
        );
      default:
        return value.value;
    }
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const TableHeader = () => {
    return (
      <TableHead>
        <TableRow>
          {data.columns &&
            Object.keys(data.columns).length > 0 &&
            Object.keys(data.columns).map((col) => (
              <TableCell key={data.columns[col].field_name}>
                {data.columns[col].display}
              </TableCell>
            ))}
        </TableRow>
      </TableHead>
    );
  };
  const createColumns = (row, rowIndex) => {
    return Object.keys(data.results[rowIndex]).map((cell) => {
      let fieldName = cell;
      return (
        <TableCell
          key={fieldName + "_" + rowIndex}
          sx={{ border: 1, borderColor: Colors.slate[300], }}
        >
          <div>
            {formatColumns(
              data.results[rowIndex][cell].type,
              data.results[rowIndex][fieldName]
            )}
          </div>
        </TableCell>
      );
    });
  };

  return (
    <div id="Report-Table" data-id="Report-Table" className="border-2 p-2" >
      <div className="txt-l font-bold bg-gray-100 p-2">{data.display_name}</div>
      <TableContainer className="overflow-auto max-h-[50vh] w-100">
        <Table stickyHeader size="small">
          <TableHeader />
          <TableBody>
            {data.results &&
              data.results.map((rows, idx) => {
                return (
                  <TableRow key={"rows_" + idx}>
                    {createColumns(rows, idx)}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ReportTable;
